module.exports = __webpack_public_path__ + "img/oil-extractor.2459a57b.png";